Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }


  const componentId = Date.now()

  const formatAmount = (amount) => {
    return new Intl.NumberFormat(ctx.component.locale, { style: 'currency', currency: ctx.component.currency }).format(amount / 100)
  }

  const displayCurrency = (currency) => {
    switch(currency) {
      case 'EUR':
        return '€'
        break
      case 'USD':
        return '$'
        break
      case 'GBP':
        return '£'
        break
      default:
        return currency
    }
  }

  let errorList = {}

  let selectedProductList = {
    items: {}
  }

  const setTotalAmount = () => {
    let totalAmount = 0

    for (let key in selectedProductList.items) {
      totalAmount += selectedProductList.items[key].totalAmount
    }

    selectedProductList.totalAmount = +totalAmount
  }

  const unsetProduct = (element) => {
    const quantity = element.dataset.quantitymin ? element.dataset.quantitymin : 1
    const counter = element.querySelector('.product_item_counter_input')

    if (counter) {
      // Reset the counter.
      element.dataset.quantity = quantity
      counter.value = quantity
    }

    delete selectedProductList.items[element.id]

    setTotalAmount()
  }

  const setValue = () => {
    if (Object.keys(selectedProductList.items).length) {
      ctx.setValue(selectedProductList)
    } else {
      ctx.deleteValue()
    }

    const hasPopulatedArray = Object.keys(errorList).some(key => Array.isArray(errorList[key]) && errorList[key].length > 0)
    ctx.instance.invalid = hasPopulatedArray
  }

  const setProduct = (element) => {
    // Return if the product is missing fields or is NaN.
    if (isNaN(element.dataset.amount)) {
      return
    }

    selectedProductList.items[element.id] = {
      id: element.id,
      label: element.dataset.label,
      description: element.dataset.description,
      iconUrl: element.dataset.iconurl,
      amount: +element.dataset.amount,
      quantity: +element.dataset.quantity,
      shippingCost: +element.dataset.shippingcost,
      shippingLabel: element.dataset.shippinglabel,
      totalAmount: (+element.dataset.amount * +element.dataset.quantity + +element.dataset.shippingcost)
    }

    setTotalAmount()

    selectedProductList.currency = element.dataset.currency
    selectedProductList.locale = element.dataset.locale
  }

  const calculateQuantityDiscount = (productItem, productData, quantity = null) => {
    // If the quantity is set through user action, use the quantity variables. Otherwise, use the first array to get the minimum of the tier.
    quantity = quantity ? quantity : productData.quantity_discount_tiers[0].quantity_discount_min_products

    productData.quantity_discount_tiers.forEach(tier => {
      if (tier.quantity_discount_min_products <= +quantity && tier.quantity_discount_max_products >= +quantity) {
        productItem.dataset.amount = tier.quantity_discount_amount_cents
        productItem.dataset.shippingcost = tier.quantity_discount_shipping_amount_cents
        productItem.dataset.shippinglabel = tier.quantity_discount_shipping_amount_label ? tier.quantity_discount_shipping_amount_label : ''

        productItem.querySelector('.product_item_amount_fixed_amount_quantity').innerHTML = quantity
        productItem.querySelector('.product_item_amount_fixed_amount').innerHTML = formatAmount(tier.quantity_discount_amount_cents)
        productItem.querySelector('.product_item_amount_fixed_total').innerHTML = formatAmount(tier.quantity_discount_amount_cents * quantity)
        productItem.querySelector('.product_item_shipping_cost').innerHTML = formatAmount(productItem.dataset.shippingcost)
        productItem.querySelector('.product_item_shipping_cost_label').innerHTML = tier.quantity_discount_shipping_amount_label ? tier.quantity_discount_shipping_amount_label : ''
      }
    })
  }

  const selectProductHandler = (e) => {
    const productItem = e.currentTarget
    const productItemCounter = productItem.querySelector('.product_item_counter_input')
    const productAmount = productItem.querySelector('.product_item_input')
    const checkbox = productItem.querySelector('.product_item_checkbox')

    const productData = ctx.component.product_list.find(item => item.id === productItem.id)

    // Calculate the amount if quantity_discount has been enabled.
    if (productData.quantity_discount) {
      calculateQuantityDiscount(productItem, productData)
    }

    if (e.target == productAmount) {
      return
    }

    // Validate on product select.
    validationHandler(productItem)

    // Listen for changes to the quantity counter.
    if (productItemCounter) {
      if (!productItemCounter.dataset.changeEvent) {
        productItemCounter.addEventListener('change', (e) => {
          // Recalculate the amount if the quantity changes.
          if (productData.quantity_discount) {
            calculateQuantityDiscount(productItem, productData, e.target.value)
          }

          if (productData.allow_multiple) {
            productItem.querySelector('.product_item_amount_fixed_amount_quantity').innerHTML = e.target.value
            productItem.querySelector('.product_item_amount_fixed_total').innerHTML = formatAmount(productItem.dataset.amount * e.target.value)
         }

          productItem.dataset.quantity = e.target.value
          setProduct(productItem)

          // Validate on every change.
          validationHandler(productItem)
          setValue()
        })
        productItemCounter.dataset.changeEvent = 'true'
      }

      productItemCounter.parentElement.classList.toggle('hidden')
    }

    // Listen for changes to the open amount input and multiply it by 100 to get the amount in cents.
    if (productAmount && productAmount.dataset.changeEvent !== 'true') {
      productAmount.addEventListener('change', (e) => {
        productItem.dataset.amount = e.target.value * 100
        setProduct(productItem)

        // Validate on every change.
        validationHandler(productItem)
        setValue()
      })

      productAmount.dataset.changeEvent = 'true'
    }

    checkbox.checked = !checkbox.checked

    if (checkbox.checked) {
      setProduct(productItem)
    } else {
      unsetProduct(productItem)

      // Clear the product and set to initial values
      if (productData.fixed_amount) {
        productItem.querySelector('.product_item_amount_fixed_total').innerHTML = formatAmount(productItem.dataset.amount)

        if (productData.allow_multiple) {
          productItem.querySelector('.product_item_amount_fixed_amount_quantity').innerHTML = productItem.dataset.quantitymin
        }
      }

      // Clear errors.
      if (errorList[productItem.id]) {
        errorList[productItem.id] = []
        productItem.parentElement.querySelector('.product_item_errors').innerHTML = ''
        productItem.classList.remove('errored', 'is-invalid')
      }
    }

    productItem.classList.toggle('selected')
    setValue()
  }

  const parseError = (product, code) => {
    const customError = ctx.component.custom_errors[code]
    const fieldsToReplace = [...customError.matchAll(/\{\{(.*?)\}\}/g)]

    let error = customError

    fieldsToReplace.forEach(([placeholder, field]) => {
      const fieldKey = field.trim().toLowerCase()
      const fieldValue = product.dataset[fieldKey]

      if (['amountmin', 'amountmax'].includes(fieldKey)) {
        error = error.replace(placeholder, formatAmount(fieldValue))
      } else {
        error = error.replace(placeholder, fieldValue)
      }
    })

    return error
  }

  const validationHandler = (product) => {
    const errorContainer = product.parentElement.querySelector('.product_item_errors')
    const quantity = +product.dataset.quantity
    const quantityMin = +product.dataset.quantitymin
    const quantityMax = +product.dataset.quantitymax
    const amount = +product.dataset.amount
    const amountMin = +product.dataset.amountmin
    const amountMax = +product.dataset.amountmax

    // Reset the error list.
    errorList[product.id] = []

    if (quantity > quantityMax) errorList[product.id].push(parseError(product, 'quantity_max'))
    if (quantity < quantityMin) errorList[product.id].push(parseError(product, 'quantity_min'))
    if (amount > amountMax) errorList[product.id].push(parseError(product, 'amount_max'))
    if (amount < amountMin) errorList[product.id].push(parseError(product, 'amount_min'))

    if (errorList[product.id]) {
      errorElements = []

      if (errorList[product.id].length === 0) {
        product.classList.remove('errored', 'is-invalid')
        errorContainer.innerHTML = ''
      } else {
        errorList[product.id].forEach(element => errorElements.push(`<li class="error">${element}</li>`))

        // Add visual error elements.
        product.classList.add('errored', 'is-invalid')
        errorContainer.innerHTML = errorElements.join(' ')
      }
    }
  }

  function modifyInput(e) {
    e.stopPropagation()

    const action = e.target.getAttribute('data-counter-action')
    const numberInput = document.getElementById(e.target.getAttribute('for'))
    numberInput[action]()

    // Force change event to trigger listeners.
    numberInput.dispatchEvent(new Event('change'))
  }

  $(function() {
    const products = document.querySelectorAll('.product_item')

    products.forEach((n) => {
      if (!n.dataset.clickEvent) {
        n.addEventListener('click', selectProductHandler)
        n.dataset.clickEvent = 'true'
      }
    })

    document.querySelectorAll('[data-counter-action]').forEach(
    (n) => {
      if (!n.dataset.clickEvent) {
        n.addEventListener('click', modifyInput) 
        n.dataset.clickEvent = 'true'
      }
    })

    document.querySelectorAll('input').forEach(
    (n) => {
      if (!n.dataset.clickEvent) {
        n.addEventListener('click', (e) => {
          e.stopPropagation()
        })
        n.dataset.clickEvent = 'true'
      }
    })

    const invalidKeys = ['-', '+']

    document.querySelectorAll('.product_list input[type="number"]').forEach((n) => {
    if (!n.dataset.keydownEvent) {
      n.addEventListener('keydown', (e) => {
        if (invalidKeys.includes(e.key)) {
          e.preventDefault()
        }
      })

      n.dataset.keydownEvent = 'true'
    }

      n.addEventListener('paste', (e) => {
        const pasteData = (e.clipboardData || window.clipboardData).getData('text')

        if (invalidKeys.some(key => pasteData.includes(key))) {
          e.preventDefault()
          n.value = pasteData.replace(/[-+]/g, '')
        }
      })
    })

    document.querySelectorAll('.product_item_input').forEach(
    (n) => {
      if (!n.dataset.inputEvent) {
        n.addEventListener('input', (e) => {
            const parentElement = e.currentTarget.closest('.product_item')
            const checkbox = parentElement.querySelector('.product_item_checkbox')

            if (!checkbox.checked) {
              parentElement.dataset.amount = e.target.value * 100

              // Click the element.
              parentElement.click()
            }
          })
          n.dataset.inputEvent = 'true'
        }
      }
    )
  })
;
__p += '\n';
 if (ctx.component.product_list) { ;
__p += '\n<div id="' +
((__t = ( ctx.id + componentId)) == null ? '' : __t) +
'" class="product_list">\n  ';
 for (let product of ctx.component.product_list) { ;
__p += '\n  <div class="product_item_container">\n    ';

        // Set the amountLabel for initial set, This changes depending on the configured amount through quantity_discount or fixed_amount.
        let amount = undefined
        let quantityMin = 1
        let quantityMax = 9999
        let totalAmount = undefined
        let shippingCost = undefined
        let shippingCostLabel = undefined

        if (product.fixed_amount) {
          amount = product.amount
        }

        if (product.shipping_amount_cents) {
          shippingCost = product.shipping_amount_cents
        }

        if (product.shipping_amount_label) {
          shippingCostLabel = product.shipping_amount_label
        }

        if (product.allow_multiple && product.quantity_min && product.quantity_max) {
          quantityMin = product.quantity_min
          quantityMax = product.quantity_max
        }

        if (product.quantity_discount && product.quantity_discount_tiers) {
          const discountTiers = product.quantity_discount_tiers

          // Get the absolute minimum & maximum of the products.
          quantityMin = discountTiers[0].quantity_discount_min_products
          quantityMax = discountTiers[discountTiers.length - 1].quantity_discount_max_products

          amount = discountTiers[0].quantity_discount_amount_cents

          // Set the first tier shipping cost.
          if (discountTiers[0].quantity_discount_shipping_amount_cents) {
            shippingCostLabel = discountTiers[0].quantity_discount_shipping_amount_label
            shippingCost = discountTiers[0].quantity_discount_shipping_amount_cents
          }
        }
      ;
__p += '\n    <div \n        id="' +
((__t = ( product.id )) == null ? '' : __t) +
'" \n        data-label="' +
((__t = ( product.label )) == null ? '' : __t) +
'" \n        data-description="' +
((__t = ( product.description )) == null ? '' : __t) +
'"\n        data-iconUrl="' +
((__t = ( product.icon_url )) == null ? '' : __t) +
'" \n        data-currency="' +
((__t = ( ctx.component.currency )) == null ? '' : __t) +
'"\n        data-locale="' +
((__t = ( ctx.component.locale )) == null ? '' : __t) +
'" \n        data-amount="' +
((__t = ( amount )) == null ? '' : __t) +
'" \n        data-shippingCost="' +
((__t = ( shippingCost )) == null ? '' : __t) +
'"\n        data-shippingLabel="' +
((__t = ( shippingCostLabel )) == null ? '' : __t) +
'" \n        data-amountMin="' +
((__t = ( product.amount_min ? product.amount_min : 1 )) == null ? '' : __t) +
'"\n        data-amountMax="' +
((__t = ( product.amount_max ? product.amount_max : 9999999 )) == null ? '' : __t) +
'" \n        data-quantity="' +
((__t = ( quantityMin )) == null ? '' : __t) +
'"\n        data-quantityMin="' +
((__t = ( quantityMin )) == null ? '' : __t) +
'" \n        data-quantityMax="' +
((__t = ( quantityMax )) == null ? '' : __t) +
'" \n        class="product_item"\n      >\n      <div class="product_item_info">\n        ';
 if (product.icon_url) { ;
__p += '\n        <img class="product_item_image" src="' +
((__t = ( product.icon_url )) == null ? '' : __t) +
'">\n        ';
 } ;
__p += '\n        <div class="product_item_text_amount">\n          <div class="product_item_text">\n            <h3 class="product_item_name">' +
((__t = ( ctx.t(product.label) )) == null ? '' : __t) +
'</h3>\n            ';
 if (product.description) { ;
__p += '\n            <p class="product_item_description">' +
((__t = ( ctx.t(product.description) )) == null ? '' : __t) +
'</p>\n            ';
 } ;
__p += '\n          </div>\n          <div class="product_item_amount_group">\n            ';
 if (product.fixed_amount || product.quantity_discount) { ;
__p += '\n            <div class="product_item_amount_fixed_total">\n              ' +
((__t = ( formatAmount(amount * quantityMin) )) == null ? '' : __t) +
'\n            </div>\n            ';
 if (product.allow_multiple || product.quantity_discount ){ ;
__p += '\n            <div class="product_item_amount_fixed">\n              ( <span class="product_item_amount_fixed_amount_quantity">' +
((__t = ( quantityMin )) == null ? '' : __t) +
'</span> x <span class="product_item_amount_fixed_amount">' +
((__t = ( formatAmount(amount) )) == null ? '' : __t) +
'</span> )\n            </div>\n            ';
 } ;
__p += '\n            ';
 } else { ;
__p += '\n            <div class="product_item_amount">\n              <span class="product_item_input_prefix">' +
((__t = ( displayCurrency(ctx.component.currency) )) == null ? '' : __t) +
'</span>\n              <input type="number" min="' +
((__t = ( product.amount_min ? product.amount_min : 0 )) == null ? '' : __t) +
'" class="product_item_input" placeholder="..." lang="' +
((__t = ( ctx.component.locale )) == null ? '' : __t) +
'">\n            </div>\n            ';
 } ;
__p += '\n          </div>\n          ';
 if (shippingCost && (product.fixed_amount || product.quantity_discount)) {  ;
__p += '\n          <small class="product_item_shipping">\n            + \n            <span class="product_item_shipping_cost">' +
((__t = ( formatAmount(shippingCost) )) == null ? '' : __t) +
'</span>\n            <span class="product_item_shipping_cost_label">';
 if (shippingCostLabel) { ;
__p +=
((__t = ( ctx.t(shippingCostLabel) )) == null ? '' : __t);
 } ;
__p += '</span>\n          </small>\n          ';
 } ;
__p += '\n        </div>\n      </div>\n      <div class="product_item_num_check">\n        ';
 if (product.allow_multiple || product.quantity_discount) { ;
__p += '\n        <div class="product_item_counter hidden">\n          <button for="product_item_counter_input-' +
((__t = ( product.id )) == null ? '' : __t) +
'" data-counter-action="stepDown" class="product_item_counter_button">\n            -\n          </button>\n          <input min="' +
((__t = ( (quantityMin > 1 ? quantityMin - 1 : 1) )) == null ? '' : __t) +
'" max="' +
((__t = (quantityMax + 1)) == null ? '' : __t) +
'" type="number" id="product_item_counter_input-' +
((__t = ( product.id )) == null ? '' : __t) +
'" class="product_item_counter_input" value="' +
((__t = ( quantityMin )) == null ? '' : __t) +
'">\n          <button for="product_item_counter_input-' +
((__t = ( product.id )) == null ? '' : __t) +
'" data-counter-action="stepUp" class="product_item_counter_button">\n            +\n          </button>\n        </div>\n        ';
 } ;
__p += '\n        <div class="product_item_check_container">\n          <input name="checkbox-' +
((__t = ( product.id )) == null ? '' : __t) +
'" type="checkbox" class="product_item_checkbox" id="checkbox-' +
((__t = ( product.id )) == null ? '' : __t) +
'">\n          <span class="product_item_checkmark"></span>\n        </div>\n      </div>\n    </div>\n    <ul class="product_item_errors">\n    </ul>\n  </div>\n  ';
 } ;
__p += '\n</div>\n';
 } ;
__p += '\n';

  $(function() {
    if (ctx.component.product_list) {
      const defaultSelectedProducts = ctx.component.product_list.reduce((accumulator, obj) => {
        if (Boolean(obj.checked) === true) { // Convert obj.checked to a boolean so that it interprets it correctly.
          const {id, ...restOfProduct} = obj

          accumulator.items[id] = restOfProduct
        }

      return accumulator
      }, { items: {} })

      const productData = ctx.data.products || (Object.keys(defaultSelectedProducts.items).length === 0 ? {} : defaultSelectedProducts)

      if (!productData.hasOwnProperty('items')) {
        return
      }

      for (const [key, product] of Object.entries(productData.items)) {
        const productElement = document.getElementById(key)
        const productElementCheckbox = document.getElementById('checkbox-' + key)

        if (!productElement || productElementCheckbox.checked) {
          continue
        }

        const productClickEvent = new Event("click")
        productElement.dispatchEvent(productClickEvent)

        const productItemCounter = productElement.querySelector('.product_item_counter_input')

        if (!productItemCounter) {
          continue
        }

        productItemCounter.value = product.quantity || 1

        const counterChangeEvent = new Event("change")
        productItemCounter.dispatchEvent(counterChangeEvent)
      }
    }
  })
;
__p += '\n';
return __p
}